import Vue from 'vue'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
// Tailwind CSS (replaces Vuetify)
import '@/assets/tailwind.css'
import App from './App.vue'
import router from './router'
import store from '@/vuex/store'
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)
// Vue.use(Vuetify)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
